import React, { useState } from "react";
import { api } from "../../lib/api";
import { useSettings } from "../../lib/useSettings";
import { Mail, Send, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function NewsletterSection() {
  const { settings: s } = useSettings();
  const c = s?.home_sections_content?.newsletter || {};
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Adresse email invalide");
      return;
    }
    setSending(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      setDone(true);
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Inscription impossible");
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="py-16 md:py-20 bg-[color:var(--brand-navy)] relative overflow-hidden" data-testid="newsletter-section">
      {c.image && (
        <img src={c.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
      )}
      <div className="absolute inset-0 bg-gradient-to-br from-[color:var(--brand-navy)]/80 to-transparent" />
      <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[color:var(--brand-sky)]/20 backdrop-blur-sm mb-5">
          <Mail className="w-6 h-6 text-white" />
        </div>
        <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--brand-sky)] font-semibold mb-3">
          {c.kicker || "Restez informé"}
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-3">
          {c.title || "Rejoignez notre newsletter"}
        </h2>
        {c.subtitle && <p className="text-white/75 max-w-xl mx-auto mb-8">{c.subtitle}</p>}

        {done ? (
          <div className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-emerald-500/20 border border-emerald-400/40 text-emerald-100 font-semibold text-sm">
            <Check className="w-4 h-4" /> Merci, votre inscription est enregistrée !
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row items-stretch gap-2 max-w-md mx-auto" data-testid="newsletter-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={c.placeholder || "votre@email.com"}
              required
              className="flex-1 h-12 px-4 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/50 focus:bg-white/15 focus:outline-none focus:border-[color:var(--brand-sky)]"
              data-testid="newsletter-email"
            />
            <button
              type="submit"
              disabled={sending}
              className="h-12 px-6 rounded-full bg-[color:var(--brand-sky)] hover:bg-[color:var(--brand-sky)]/90 text-white font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="newsletter-submit"
            >
              {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              {c.button_label || "Je m'inscris"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
